<template>
  <div id="app">

  <Paper v-if="template == 'page'" :id="id" :config="config" :project="project" :header="header" :logos="logos" :raw="raw" :menu="config && config.menu" :views="views" :json="json" :edit="true" />
<Project v-else />

  </div>
</template>

<script>
import Paper from './components/Paper.vue';
import Project from './components/Project.vue';
var YAML = require("yamljs");
import WebFontLoader from 'webfontloader';
import { bus } from "@/main";

export default {
  name: 'App',
  components: {
    Paper,
    Project
  },
  data() {
    return {
      id: null,
      project: null,
      header: null,
      logos: null,
      menu: null,
      template: null,
      json: null,
      text: null,
      raw: null,
      words: null,
      config: null,
      views: null
    }
  },
  methods: {
    convertJson(text) {
      var regex = /&(?!#?[a-z0-9]+;)/gm;
      var html = text.replace('/n', '').replace(/\n/g, '').replace(regex, "&amp;");

      const doc = new DOMParser().parseFromString("<body>" + html + "</body>", "text/xml");
         
      var main = doc.querySelector('body').childNodes;
      var array = Array.prototype.slice.call(main);
      this.json = array.map((x) => x.outerHTML);

          // main.forEach(
          //   function(currentValue) {
          //      console.log(currentValue);
          //     console.log(currentValue.nodeType);
          //   }
          // );
      this.createViews(this.json);
    },
    createViews(array) {

      var views = [];

      for (var x = 0; x < array.length; x++) {

          var element = document.createElement("div");
          element.innerHTML  = array[x];
          element = element.firstElementChild;
          let name = element.nodeName;
          let type = element && element.childNodes[0] && element.childNodes[0].nodeType;
          var view;

          if (element.nodeName == "MENU") {
            view = this.createMenu(element);
            this.menu = view;
          }
          if (element.nodeName == "HEADER") {
            view = this.parseHeader(element);
            this.header = view;
          }
          if (element.nodeName == "LOGOS") {
            view = this.parseLogos(element);
            this.logos = view;
          }
          if (element.nodeName == "H1" || element.nodeName == "H2" || element.nodeName == "H3") {
            view = this.createTitle(element);
            views.push(view)
          }
          if (element.nodeName == "IMG") {
            view = this.createImage(element);
            views.push(view)
          }
          if (element.nodeName == "VIEW") {
            view = this.createView(element);
            views.push(view)
          }
          if (element.nodeName == "LIST") {
            view = this.createList(element);
            views.push(view)
          }
          if (element.nodeName == "CARDS") {
            view = this.createCards(element);
            views.push(view)
          }
          if (element.nodeName == "GALLERY") {
            view = this.createGallery(element);
            views.push(view)
          }
          if (type && type == 3 && name == "P" || element.nodeName == "UL" || element.nodeName == "LIST") {
            view = this.createText(element);
            views.push(view)
          }
          if (type && type == 1 && name == "P") {
            var childName = element.firstElementChild.nodeName;
            var childContent = element.firstElementChild;
            if (childName == "IMG") {
              view = this.createImage(childContent)
            }
            if (this.parseVideo(childContent.innerHTML)) {
              view = this.parseVideo(childContent.innerHTML);
            }
            else if (childName == "A") {
              view = this.createText(element);
            }
            views.push(view)
          }
        
      }

      if (!this.header){
        var image; var title; var text; var links;

        if (views[0].type == 'image') {
          image = views[0].url;
          views.splice(0,1);
        }
        if (views[0].level == 'H1') {
          title = views[0].content;
          views.splice(0,1);
        }
        if (image && title && views[0].type == 'text') {
          text = "<p>" + views[0].content + "</p>";
          views.splice(0,1);
        }
        if (image && title && text && views[0].type == 'text') {
          links = this.createLinks(views[0].content);
          views.splice(0,1);
        }

        var obj = {
          type: "header",
          title: title,
          text: text,
          image: image,
          links: links
        }
        this.header = obj;

      }

      this.views = views;

    },
    getConfig(text) {
        var code = text.match(/```([^`]*)```/);
        if (code) {
        this.config = YAML.parse(code[1]);
        }
    },
    parseVideo(text) {
      var hasVideo = text.match(
        /(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\S+)?/
      );

      var obj = {
        "type": "video",
        "content": null
      }

      if (hasVideo && RegExp.$3.indexOf("youtu") > -1) {
        obj["youtube"] = RegExp.$6;
        return obj
      } else if (hasVideo && RegExp.$3.indexOf("vimeo") > -1) {
        obj["vimeo"] = RegExp.$6;
        return obj
      } else {
        return false;
      }
    },
    parseHeader(element) {
      var title = element.querySelector("h1").outerHTML;
      var text = element.querySelector("p").outerHTML;
      var image = element.getAttribute("image");
      var obj = {
        type: "header",
        title: title,
        text: text,
        image: image,
        config: this.getAttributes(element)
      }
      if (element.querySelector("h2")) {
        obj["subtitle"] = element.querySelector("h2").outerHTML;
      }
      return obj;
    },
    getAttributes(element) {
      var attrs = element.attributes;
      var obj = {};
      for (var i = attrs.length - 1; i >= 0; i--) {
        var attrname = attrs[i].name;
        var attrvalue = attrs[i].value;
        if (attrvalue == "true") {
          obj[attrname] = true;
        } else if (attrvalue == "false") {
          obj[attrname] = false;
        } else {
          obj[attrname] = attrvalue;
        }
      }
      return obj;
    },
    createView(view) {
      var text = view.innerHTML.split('<p>--</p>');
      var obj = {
        type: "view",
        content: text,
        config: this.getAttributes(view)
      }
       return obj;
    },
    createImage(element) {
      var obj = {};
      obj["type"] = 'image';
      obj["url"] = element.getAttribute("src");
      obj["caption"] = element.getAttribute("alt");
      return obj
    },
    createLogo(element) {
      var obj = {};
      var link = element.firstElementChild;
      var image = link.firstElementChild;
      obj["type"] = 'logo';
      obj["url"] = link.getAttribute("href");
      obj["image"] = image.getAttribute("src");
      obj["caption"] = image.getAttribute("alt").split("|")[0] || image.getAttribute("alt");
      return obj
    },
    createGallery(view) {
      var images = view.firstElementChild.childNodes;
      var array = Array.prototype.slice.call(images).map((x) => this.createImage(x));
      var obj = {
        type: "gallery",
        content: array,
        config: this.getAttributes(view)
      }
       return obj;
    },
    parseLogos(view) {
      var images = view.childNodes;
      console.log(images);
      var array = Array.prototype.slice.call(images).map((x) => this.createLogo(x));
      var obj = {
        type: "logos",
        content: array,
        config: this.getAttributes(view)
      }
      console.log(array);
       return obj;
    },
    createList(view){
      var obj = {
        type: "list",
        config: this.getAttributes(view)
      }
      return obj;
    },
    createLinks(element) {
      var doc = document.createElement("div");
      doc.innerHTML = element;
      var links = doc.childNodes;
      var array = Array.prototype.slice.call(links).map((x) => this.createLink(x));
      return array;
    },
    createLink(element) {
      var obj = {
        url: element.getAttribute("href"),
        text: element.textContent
      }
      return obj
    },
    createCard(element){
      var doc = document.createElement("div");
      doc.innerHTML  = element;
      var obj = {
        title: doc.querySelector("a").textContent,
        image: doc.querySelector("img").getAttribute("src"),
        text: doc.querySelectorAll("p")[2].textContent,
        url: doc.querySelector("a").getAttribute("href")
      }
      return obj
    },
    createCards(view) {
      var cards = view.innerHTML.split('<p>--</p>');
      var array = cards.map((x) => this.createCard(x));
      var obj = {
        type: "cards",
        content: array,
        config: this.getAttributes(view)
      }
       return obj;
    },
    createMenu(view) {
       var obj = {
        type: "menu",
        content: view.textContent
       }
       return obj;
    },
    createHeader(view) {
      var obj = {
        type: "header",
      }
      var elements = this.parseHeader(view.innerHTML);
      obj["title"] = elements.title;
      obj["subtitle"] = elements.subtitle;
      obj["text"] = elements.text;

      if (view.hasAttributes()) {
        var config = this.getAttributes(view);
        obj["config"] = config;
      }
      
       return obj;
    },
    createTitle(view) {
       var obj = {
        type: "title",
        content: view.textContent,
        level: view.nodeName
       }
       return obj;
    },
    createText(view) {
       var obj = {
        type: "text",
        content: view.innerHTML
       }
       return obj;
    },
    createText2(view) {
        var htmlblock = view.innerHTML;
            var arrayBlock = htmlblock.split("---");
            var test = arrayBlock.map((x) => window.md.render(x));
            var obj = {
              type: "text",
              content: test
             }
             return obj;
    },
    parseText(text) {
      var regex = /^![[^]]*]\((?<filename>.*?)(?="|\))(?<optionalpart>".*")?\)/g;
      var html = text;
      return window.md.render(html.replace(regex, ""));
    },
    wordCount(text) {
      return text.split(" ").length;
    },
    loadPage(id){
      var self = this;
      self.id = id;
      this.header = null;

      fetch("https://edgeryders.eu/raw/" + id)
          .then(response => {
            response.text().then(function(text) {
                self.text = text;
                self.raw = self.parseText(text);
                self.text = self.raw.replace(/<(.|\n)*?>/g, "");
                self.words = self.wordCount(text);
                self.getConfig(text);
                self.convertJson(window.md.render(text.replace(/---+/g, '--')));
                self.template = 'page';
            });
          })
          .catch(error => console.error(error));
    },
    loadProject(id){
      var self = this;
      self.id = id;
      self.template = 'project';
      this.$router.push({ path: `/project/` + id });
    }
  },
  created() {
    WebFontLoader.load({
      google: {
        families: ['Playfair Display:400', 'Homemade Apple', 'Open Sans:400,600,700'],
      }
    });

    var id = window.location.pathname.split("/").slice(-1)[0];
    if (!isNaN(id)) {
      this.loadPage(id);
    }
    
    bus.$on("loadPage", data => {
      this.loadPage(data.id, data.project);
    });

    bus.$on("loadProject", id => {
      this.loadProject(id);
    });
  }
}
</script>

<style lang="scss">

#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #000;
}

.edit_sidebar {
  width: 400px;
  flex-shrink: 0;
  height: 100vh;
  left: 0;
  top: 0;
  background: #fafafa;
  @apply border-r;
  h2 {
    @apply text-2xl font-bold border-b mb-3 mt-6;
  }
}

.main {
  padding: 20px;
  flex-grow: 1;
  height: 100vh;
  overflow: scroll;
}
</style>
